{
  "tagline": "Real conversations start nearby.",
  "findingYourSpace": "Finding your space…",
  "welcome": {
    "greeting": "Hi!",
    "headline": "Break the ice & Meet new people",
    "continueWithEmail": "Continue with Email",
    "continueWithApple": "Continue with Apple",
    "continueWithGoogle": "Continue with Google",
    "legalAgreement": "By continuing you agree to our <terms>Terms of Service</terms> and <privacy>Privacy Policy</privacy>.",
    "emailTitle": "Enter your email",
    "emailDescription": "We’ll send you a verification code.",
    "emailLabel": "Email",
    "emailPlaceholder": "you@email.com",
    "sendCode": "Send me a code",
    "invalidEmail": "Enter a valid email address.",
    "signInError": "Something went wrong. Try again.",
    "signingIn": "Signing you in…",
    "appleOnlyOnIosTitle": "Apple sign-in",
    "appleOnlyOnIosBody": "Signing in with Apple is only available on iOS devices.",
    "appleUnavailableTitle": "Apple sign-in unavailable",
    "appleUnavailableBody": "Apple sign-in needs a development build (it isn’t supported in Expo Go). Use email for now.",
    "appleFailedTitle": "Apple sign-in failed",
    "appleMissingTokenBody": "We didn’t receive a token. Try again.",
    "appleFailedBody": "Please try again.",
    "finishingApple": "Finishing Apple sign-in...",
    "finishingGoogle": "Finishing Google sign-in..."
  },
  "verify": {
    "title": "Check your email",
    "codeSent": "We sent a 6-digit code to",
    "codeLabel": "Verification code",
    "verify": "Verify",
    "missingCodeError": "Enter the code from your email.",
    "invalidCodeError": "That code did not work. Try again.",
    "suspendedError": "Your account has been suspended. Please contact support if you think this is a mistake.",
    "resendError": "Could not resend the code. Try again.",
    "didntReceive": "Didn’t receive the email?",
    "resendCode": "Resend code",
    "resendIn": "Resend in {{seconds}}s",
    "changeEmail": "Change email address",
    "lostTitle": "Start again to get a new code",
    "lostBody": "We lost track of which email this code was for. Enter your email and we’ll send a fresh one.",
    "lostAction": "Enter your email",
    "expiredCodeError": "That code has expired. Send yourself a new one.",
    "tooManyError": "Too many attempts. Wait a minute and try again.",
    "tooManyAttemptsError": "Too many attempts. Try again in {{countdown}}.",
    "burnedCodeError": "Too many incorrect attempts. Send yourself a new code.",
    "codeLengthError": "Enter all 6 digits.",
    "serviceError": "We couldn’t check that code just now. Try again in a moment.",
    "offlineError": "No connection. Check your network and try again."
  },
  "unavailable": {
    "title": "We can't load your account",
    "body": "You're still signed in — we just couldn't reach Opncue to load your profile. This is usually a connection problem.",
    "signOut": "Sign out instead"
  }
}
